var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: { close: _setup.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _setup.localFormData,
                rules: _setup.formRules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              !_setup.isOnLineServiceC
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客服名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入客服名称",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _setup.localFormData.name,
                          callback: function ($$v) {
                            _vm.$set(_setup.localFormData, "name", $$v)
                          },
                          expression: "localFormData.name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_setup.isOnLineServiceC
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客服账号", prop: "account" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入客服账号",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _setup.localFormData.account,
                          callback: function ($$v) {
                            _vm.$set(_setup.localFormData, "account", $$v)
                          },
                          expression: "localFormData.account",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "配置地址", prop: "config_url" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入配置地址",
                      maxlength: "255",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _setup.localFormData.config_url,
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData, "config_url", $$v)
                      },
                      expression: "localFormData.config_url",
                    },
                  }),
                ],
                1
              ),
              !_setup.isOnLineServiceC
                ? _c(
                    "el-form-item",
                    { attrs: { label: "图标", prop: "icon_url" } },
                    [
                      _c(_setup.SingleImageUpload, {
                        attrs: { size: 100 },
                        model: {
                          value: _setup.localFormData.icon_url,
                          callback: function ($$v) {
                            _vm.$set(_setup.localFormData, "icon_url", $$v)
                          },
                          expression: "localFormData.icon_url",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_setup.isOnLineServiceC
                ? _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _setup.localFormData.status,
                            callback: function ($$v) {
                              _vm.$set(_setup.localFormData, "status", $$v)
                            },
                            expression: "localFormData.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("启用"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("停用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_setup.isOnLineServiceC
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客服类型", prop: "type_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择客服类型" },
                          model: {
                            value: _setup.localFormData.type_id,
                            callback: function ($$v) {
                              _vm.$set(_setup.localFormData, "type_id", $$v)
                            },
                            expression: "localFormData.type_id",
                          },
                        },
                        _vm._l(_vm.typeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_setup.isOnLineServiceC
                ? _c(
                    "el-form-item",
                    { attrs: { label: "适用VIP等级", prop: "vip_limit" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            value:
                              _setup.localFormData.vip_limit.length ===
                              (_setup.vipOptions?.length || 0),
                          },
                          on: { change: _setup.handleAllVipChange },
                        },
                        [_vm._v("全部")]
                      ),
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _setup.localFormData.vip_limit,
                            callback: function ($$v) {
                              _vm.$set(_setup.localFormData, "vip_limit", $$v)
                            },
                            expression: "localFormData.vip_limit",
                          },
                        },
                        _vm._l(_setup.vipOptions, function (item) {
                          return _c(
                            "el-checkbox",
                            { key: item.value, attrs: { label: item.value } },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_setup.isOnLineServiceC
                ? _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _c("el-input-number", {
                        staticClass: "sort-input",
                        attrs: {
                          min: 0,
                          max: 9999,
                          "controls-position": "right",
                        },
                        model: {
                          value: _setup.localFormData.sort,
                          callback: function ($$v) {
                            _vm.$set(_setup.localFormData, "sort", $$v)
                          },
                          expression: "localFormData.sort",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _setup.handleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _setup.loading },
              on: { click: _setup.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }